import { DOCUMENT, inject, Service } from '@angular/core';
import { ServerEnvironmentService } from '@core/providers/server-environment/server-environment.service';

@Service()
export class GoogleAnalyticsService {
  private serverEnvironment = inject(ServerEnvironmentService);
  private document = inject<Document>(DOCUMENT);

  private hasGAScriptBeenInjected = false;

  injectGAScript(): void {
    if (this.hasGAScriptBeenInjected) {
      this.warnAboutDoubleInjection();
    }

    this.serverEnvironment.getServerEnvironmentConfig$().subscribe(serverEnvironment => {
      this.createAndInjectGAScriptNode(serverEnvironment?.google?.googleAnalyticsId);
    });
  }

  private createAndInjectGAScriptNode(googleAnalyticsId: string): void {
    if (!googleAnalyticsId) {
      // this might happen on dev/QA environments
      return;
    }
    const tagContents = `
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', '${googleAnalyticsId}', 'auto');
    `;
    const tag = document.createElement('script');

    tag.innerHTML = tagContents;
    const scriptParent = this.document.getElementsByTagName('script')[0].parentElement;

    if (!scriptParent) {
      return;
    }

    scriptParent.appendChild(tag);
    this.hasGAScriptBeenInjected = true;
  }

  private warnAboutDoubleInjection(): void {
    console.warn('Analytics requested to be injected more than once');
  }
}
